import divider_1 from './divider_1.svg';
// import divider_2 from './divider_2.svg';
import divider_2 from './divider_2.png';

export const dividers = {
  divider_1,
  divider_2: divider_2.src,
};
